
import DeveloperSelector from '../DeveloperSelector/index.vue';
import MainEditor from '@/views/mindworks/components/MainEditor.vue';
import PosterSelector from '@/views/mindworks/components/PosterSelector.vue';
import DesignerSelector from '../DesignerSelector/index.vue';
import AdvertiserSelector from '../AllAdvertiserSelector/index.vue';
import DemanderSelector from '../DemanderSelector/index.vue';
import AccountMgrSelector from '../AccountMgrSelector/index.vue';
import TesterSelector from '../TesterSelector/index.vue';
import CategorySelector from '../CategorySelector/index.vue';
import BasePackageTagSelector from '../BasePackageTagSelector/index.vue';
import AppCategorySelector from '../AppCategorySelector/index.vue';
import BasePackageTagCheckbox from '../BasePackageTagCheckbox/index.vue';
import PlatformSelector from '../PlatformSelector/index.vue';
import LanguageSelector from '../LanguageSelector/index.vue';
import PrioritySelector from '../PrioritySelector/index.vue';
import TestStatusSelector from '../TestStatusSelector/index.vue';
import InteractiveChannelSelector from '../InteractiveChannelSelector/index.vue';
import DemandSelector from '../DemandSelector/index.vue';
import SingleImageUploader from '../SingleImageUploader/index.vue';
import SingleFileUploader from '../SingleFileUploader/index.vue';
import FileUploader from '../FileUploader/index.vue';
import CascaderMulti from '../cascaderMulti/index';
import BasicPackSelector from '../BasicPackSelector/index.vue';
import PmTeamsSelector from '../PmTeamsSelector/index.vue';
import CreativeDirectionSelector from '../CreativeDirectionSelector/index.vue';
import TagCascaderMulti from '../TagCascaderMulti/index.vue';
import mixin from './mixin';
import PlannerSelector from '@/components/PlannerSelector';
import AccountMtgSelector from '../AccountMtgSelector/index.vue';

export default {
  name: 'BusinessDynamicFormItem',

  componentName: 'BusinessDynamicFormItem',

  components: {
    PlannerSelector: PlannerSelector,
    TesterSelector: TesterSelector,
    DeveloperSelector: DeveloperSelector,
    DesignerSelector: DesignerSelector,
    AdvertiserSelector: AdvertiserSelector,
    CategorySelector: CategorySelector,
    BasePackageTagSelector: BasePackageTagSelector,
    AppCategorySelector: AppCategorySelector,
    BasePackageTagCheckbox: BasePackageTagCheckbox,
    PlatformSelector: PlatformSelector,
    DemanderSelector: DemanderSelector,
    LanguageSelector: LanguageSelector,
    PrioritySelector: PrioritySelector,
    TestStatusSelector: TestStatusSelector,
    InteractiveChannelSelector: InteractiveChannelSelector,
    DemandSelector: DemandSelector,
    SingleImageUploader: SingleImageUploader,
    SingleFileUploader: SingleFileUploader,
    FileUploader: FileUploader,
    CascaderMulti: CascaderMulti,
    BasicPackSelector: BasicPackSelector,
    PmTeamsSelector: PmTeamsSelector,
    CreativeDirectionSelector: CreativeDirectionSelector,
    AccountMgrSelector: AccountMgrSelector,
    PosterSelector: PosterSelector,
    MainEditor: MainEditor,
    TagCascaderMulti: TagCascaderMulti,
    AccountMtgSelector: AccountMtgSelector
  },

  props: {
    config: {
      type: Object,
      required: true
    },
    formValue: {
      type: Object,
      required: true
    }
  },

  mixins: [mixin],

  data: function data() {
    return {};
  },


  computed: {},

  mounted: function mounted() {
    // console.log(this.innerConfig.params)
  }
};